<template>
  <div class="entry-content">
    <div class="container">
      <div class="row">
        <div class="content-area col-lg-9 col-md-9 col-sm-12 col-xs-12">
          <div class="blog-list">
            <article class="post-box" :key="key" v-for="(article, key) in posts.list">
              <div class="post-inner">
                <div class="entry-media">
                  <div class="post-cat">
                    <span class="posted-in" v-if="article.tags">
                      <a :href="`?tag=${tag}`" :key="tagKey" v-for="(tag, tagKey) in article.tags?.split(',')" rel="category tag">{{ tag }}</a>
                    </span>
                  </div>
                  <a :href="`/${article.link}`">
                    <img :src="`${article.thumbnail ? convertImageToSized(article.thumbnail, dimensions.ARTICLE) : noImage(dimensions.ARTICLE)}`" alt="" />
                  </a>
                </div>
                <div class="inner-post">
                  <div class="entry-header">
                    <div class="entry-meta">
                      <span class="byline"
                        ><a class="url fn n" href="#"><i class="flaticon-user"></i> {{ article.author }}</a></span
                      >
                      <span class="posted-on">
                        <a href="#"
                          ><i class="flaticon-clock"></i> <time class="entry-date published">{{ dateFormat(article.date) }}</time></a
                        >
                      </span>
                      <!--                      <span class="comment-num">-->
                      <!--                        <a href="#"><i class="flaticon-chat"></i> 3 Comments</a>-->
                      <!--                      </span>-->
                    </div>
                    <!-- .entry-meta -->

                    <h3 class="entry-title">
                      <a :href="`/${article.link}`">{{ article.name }}</a>
                    </h3>
                  </div>
                  <!-- .entry-header -->

                  <div class="entry-summary the-excerpt">
                    <p v-html="article.seo"></p>
                  </div>
                  <!-- .entry-content -->
                </div>
              </div>
            </article>
          </div>

          <q-pagination
            v-model="page"
            :input-class="{ 'class-nameee': true }"
            color="light-blue-4"
            round
            :max="pages"
            size="2rem"
            gutter="1rem"
            :max-pages="15"
            boundary-numbers
            @update:model-value="changePage"
          />
          <!--          <ul class="page-pagination">-->
          <!--            <li>-->
          <!--              <span aria-current="page" class="page-numbers current" :key="key" v-for="(page, key) in pages"> {{ page }}</span>-->
          <!--            </li>-->
          <!--            <li><a class="page-numbers" href="#">2</a></li>-->
          <!--            <li><a class="page-numbers" href="#">3</a></li>-->
          <!--            <li>-->
          <!--              <a class="next page-numbers" href="#"><i class="flaticon-arrow-pointing-to-right"></i></a>-->
          <!--            </li>-->
          <!--          </ul>-->
        </div>

        <aside class="widget-area primary-sidebar col-lg-3 col-md-3 col-sm-12 col-xs-12">
          <user-info />
          <section class="widget widget_categories">
            <h5 class="widget-title">Kategoriler</h5>
            <ul>
              <li :key="key" v-for="(category, key) in categories">
                <a :href="category.link">{{ category.name }}</a>
              </li>
              <!--              <li><a href="#">SEO</a> <span class="posts-count">(3)</span></li>-->
            </ul>
          </section>
          <section id="search-2" class="widget widget_search">
            <form role="search" method="get" id="search-form" class="search-form" action="">
              <input type="search" v-model="search" class="search-field" placeholder="Ara…" name="search" />
              <button type="submit" class="search-submit">
                <i class="flaticon-search"></i>
              </button>
            </form>
          </section>
          <!--          <section class="widget widget_recent_news">-->
          <!--            <h5 class="widget-title">En Çok Okunan</h5>-->
          <!--            <ul class="recent-news clearfix">-->
          <!--              <li class="clearfix">-->
          <!--                <div class="thumb">-->
          <!--                  <a href="single-blog.html">-->
          <!--                    <img src="https://via.placeholder.com/70x70.png" class="" alt="" />-->
          <!--                  </a>-->
          <!--                </div>-->
          <!--                <div class="entry-header">-->
          <!--                  <h6>-->
          <!--                    <a href="single-blog.html">15 SEO Best Practices: Website Architecture</a>-->
          <!--                  </h6>-->
          <!--                  <span class="post-on"><span class="entry-date">November 21, 2019</span></span>-->
          <!--                </div>-->
          <!--              </li>-->

          <!--              <li class="clearfix">-->
          <!--                <div class="thumb">-->
          <!--                  <a href="single-blog.html">-->
          <!--                    <img src="https://via.placeholder.com/70x70.png" alt="" />-->
          <!--                  </a>-->
          <!--                </div>-->
          <!--                <div class="entry-header">-->
          <!--                  <h6>-->
          <!--                    <a href="single-blog.html">SEO Best Practices: Mobile Friendliness</a>-->
          <!--                  </h6>-->
          <!--                  <span class="post-on"><span class="entry-date">November 21, 2019</span></span>-->
          <!--                </div>-->
          <!--              </li>-->

          <!--              <li class="clearfix">-->
          <!--                <div class="thumb">-->
          <!--                  <a href="single-blog.html">-->
          <!--                    <img src="https://via.placeholder.com/70x70.png" alt="" />-->
          <!--                  </a>-->
          <!--                </div>-->
          <!--                <div class="entry-header">-->
          <!--                  <h6>-->
          <!--                    <a href="single-blog.html">A Guide to Google SEO Algorithm Updates</a>-->
          <!--                  </h6>-->
          <!--                  <span class="post-on"><span class="entry-date">September 24, 2019</span></span>-->
          <!--                </div>-->
          <!--              </li>-->
          <!--            </ul>-->
          <!--          </section>-->
          <section id="instagram_widget-1" class="widget instagram_widget">
            <h5 class="widget-title">Instagram</h5>
            <div class="elfsight-app-28bcc7c1-bd6f-4d03-a578-317a16d8b949"></div>
          </section>
          <section id="tag_cloud-1" class="widget widget_tag_cloud">
            <h5 class="widget-title">Tags</h5>
            <div class="tagcloud">
              <a :href="`?tag=${tag}`" :key="key" v-for="(tag, key) in allTags" class="tag-cloud-link">{{ tag }}</a>
            </div>
          </section>
        </aside>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import UserInfo from 'components/Partial/UserInfo.vue';
import { PageStore } from 'stores/Page/Page.ts';
import { storeToRefs } from 'pinia';

export default defineComponent({
  name: 'Posts',
  components: { UserInfo },

  inject: ['siteContent'],

  data() {
    return {
      search: '' as string | string[],
      page: 1,
    };
  },

  computed: {
    siteURL() {
      return this.head.title.siteAdresi;
    },
    posts() {
      return this.siteContent.posts;
    },
    categories() {
      return this.siteContent.categories;
    },
    allTags() {
      return this.siteContent.allTags;
    },
    pageInfo() {
      return this.siteContent.pageInfo;
    },
    currentPage() {
      return this.$route.query.page || 1;
    },
    pages() {
      return Math.floor(this.posts.count / this.pageInfo.postListLimit) || 1;
    },
    dimensions() {
      return this.pageInfo.postImageDimensions;
    },
  },

  setup() {
    const pageStore = PageStore();
    const { head } = storeToRefs(pageStore);

    return {
      head,
    };
  },

  methods: {
    dateFormat(date: string) {
      return new Intl.DateTimeFormat(this.head.info.lang, {
        dateStyle: 'long',
        timeStyle: 'short',
      }).format(new Date(date));
    },
    changePage(val: number) {
      this.$router.replace({ path: this.$route.path, query: { ...this.$route.query, ...{ page: val } } }).then((data) => {
        window.location.replace(this.$route.fullPath);
      });
    },
    convertImageToSized(image: string, sizes: [number, number]) {
      if (!image) return;

      const [name, ext] = image.split('.');
      const [width, height] = sizes;

      return `${this.siteURL}/images/yazilar/resized/${name}-${width}-${height}.${ext}`;
    },
    noImage(dimensions: [number, number]) {
      return this.convertImageToSized('no-image-icon-23485-01092023233150.png', dimensions);
    },
  },

  created() {
    if (this.$route.query.search) {
      this.search = String(this.$route.query.search);
    }
    if (this.$route.query.page) {
      this.page = Number(this.$route.query.page);
    }
  },
});
</script>

<style scoped>
::v-deep .q-pagination__content .bg-light-blue-4.q-btn:before {
  box-shadow: 6px 6px 13px 0px rgba(0, 195, 255, 0.3);
}
</style>
